module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAM1BMVEUAAAChoaGampqcnJyZmZmampqampqZmZmZmZmampqampqbm5ucnJyqqqqcnJyampqZmZlWCDxKAAAAEHRSTlMABbE686vx2MiagV0dDEhHmNmb+AAAAGJJREFUSMft1ssNwCAMBFEnxCTk6/6rjRAVeK7s3p+ExMFjc+5h7N2jnkvelehb89IDyiOgbAHlXaksm6SkZE66UXlR6Rjip0Ln+Dvk5GZ3+JQ36HiuOHQ8yewbEciyUxv7Acj4F4i1P/pVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-arrow.png
// module id = nAKJ
// module chunks = 1